const KEY = "teller_auth";

export function saveAuth(role, token, team = null) {
  localStorage.setItem(KEY, JSON.stringify({ role, token, team }));
}

export function getAuth() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getTeam() {
  const a = getAuth();
  return a?.team || null;
}

export function clearAuth() {
  localStorage.removeItem(KEY);
}

export function hasRole(roles) {
  const a = getAuth();
  if (!a) return false;
  return roles.includes(a.role);
}
